import { render, staticRenderFns } from "./SignaturePositionsModal.vue?vue&type=template&id=5bb123a9&scoped=true&lang=html"
import script from "./SignaturePositionsModal.vue?vue&type=script&lang=js"
export * from "./SignaturePositionsModal.vue?vue&type=script&lang=js"
import style0 from "./SignaturePositionsModal.vue?vue&type=style&index=0&id=5bb123a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb123a9",
  null
  
)

export default component.exports